import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const { settings } = useContent();
  const s = settings || {};
  return (
    <footer data-testid="site-footer" className="border-t border-hairline/60 bg-ink">
      <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="font-display text-3xl font-bold tracking-tight text-bone">
              PRASCAK <span className="text-kinetic">4</span> PRESIDENT
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-bone/55">
              {s.tagline || "Country over party. People over politics."}
            </p>
          </div>

          <div>
            <div className="mb-4 text-xs uppercase tracking-[0.22em] text-bone/40">Explore</div>
            <ul className="space-y-3 text-sm text-bone/70">
              <li><Link className="link-underline" to="/policy">Policy Statements</Link></li>
              <li><Link className="link-underline" to="/beliefs">Political Beliefs</Link></li>
              <li><Link className="link-underline" to="/donate">Donate</Link></li>
            </ul>
          </div>

          <div>
            <div className="mb-4 text-xs uppercase tracking-[0.22em] text-bone/40">Connect</div>
            <ul className="space-y-3 text-sm text-bone/70">
              {(s.social_links || []).map((l, i) => (
                <li key={i}>
                  <a className="link-underline" href={l.url} target="_blank" rel="noreferrer">{l.label}</a>
                </li>
              ))}
              {s.footer_email && (
                <li><a className="link-underline" href={`mailto:${s.footer_email}`}>{s.footer_email}</a></li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-hairline/50 pt-6 text-xs text-bone/40 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} {s.candidate_name || "Mark Prascak"}. Paid for by Prascak 4 President.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="uppercase tracking-[0.2em] text-bone/30 hover:text-bone/70">
            Team Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
